import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { CommonService } from "app/reusable/common.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-delete-location-type",
  templateUrl: "./delete-location-type.component.html",
  styleUrls: ["./delete-location-type.component.scss"],
})
export class DeleteLocationTypeComponent implements OnInit, OnDestroy {
  @Input() locationtype: any;
  @Output() Change = new EventEmitter();
  private _subject$: Subject<boolean> = new Subject();

  constructor(private commonService: CommonService) { }

  ngOnInit() {
  }

  public Delete() {
    let deleteUrl: string = `Location/Delete/${this.locationtype.lctId}`;
    this.commonService.delete(deleteUrl).pipe(takeUntil(this._subject$)).subscribe((res) => {
      this.Change.emit({ lctId: this.locationtype.lctId, dialogstatus: false });
    });
  }

  public Cancel() {
    this.Change.emit({ lctId: null, dialogstatus: false });
  }

  ngOnDestroy() {
    this._subject$.unsubscribe();
  }
}